// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.comp[data-v-3449f837]\n{\n    padding-top: 2px;\n    margin-top: 12px;\n}\n.v-text-field[data-v-3449f837]\n{\n    padding-top: 2px;\n    margin-top: 2px;\n}\n.v-input--selection-controls[data-v-3449f837]\n{\n    margin-top: 4px;\n    padding-top: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
